import createBaseService from "@/api/base-service";
import type { Bom } from "../../types/bom";
import { apiClient } from "@/api/api-client";

export type BomBrand = {
    id: number;
    brand_name: string;
};

const bomService = {
    // Bom in type shows a full schema 
    ...createBaseService<Bom>("/bom"),

    list: async (): Promise<Bom[]> => {
        const response = await apiClient.get<Bom[]>("/bom");
        return response.data;
    },
}

export default bomService;  